<div class="review-summary-table d-none d-lg-block">
  <table class="table w-100 table-striped">
    <thead>
      <tr>
        <th class="col-md-3">{{ "NAME" | globalTranslate }}</th>
        <th class="col-md-4">{{ "What Changed?" | globalTranslate }}</th>
        <th class="col-md-3">
          <span class="visually-hidden">Actions</span>
        </th>
        @if (!this.isRMC) {
        <th class="col-md-2">{{ "Review Complete?" | globalTranslate }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rowData; track row; let rowIndex = $index) {
      <tr>
        <td>
          {{ row.nameAge }}
        </td>
        <td>
          @if (!isObject(row)) {
          <span
            [innerHtml]="
              row.changeValue
                | globalTranslate
                | restoreindiv: row.indivName
                | sanitize
            "
          ></span>
          } @if (isObject(row) && row.exportingStatus !== 'REMOVED') {
          <span>
            @if (row.changeValue.length > 0) {
            <div>
              @for (item of row.changeValue; track item) {
              <div class="pt-1">
                @if (item.key !== 'RELATIONSHIP_TO_INDIV') {
                <span>
                  <strong
                    [innerHTML]="
                      getLabelKey(item.key)
                        | translate
                        | replaceindiv: row.nameAge
                        | replacemedicaltype: row?.data?.medicalBillType?.value
                        | replaceassettype
                          : (this.currentLang == 'en'
                              ? row?.data?.assetType?.value
                              : row?.data?.assetType?.spValue)
                        | globalTranslate
                        | restoreindiv: row.nameAge
                    "
                  ></strong
                  ><br />
                  @if (!shouldSkipGlobalTranslate(item)) {
                  <span
                    [innerHtml]="item.value | globalTranslate | sanitize"
                  ></span>
                  } @if (shouldSkipGlobalTranslate(item)) {
                  <span [innerHtml]="item.value | sanitize"></span>
                  }
                </span>
                } @if (item.key === 'RELATIONSHIP_TO_INDIV') {
                <span>
                  <strong
                    [innerHTML]="
                      getLabelKey(item.key)
                        | translate
                        | replaceindiv: row.data?.casehead?.fullName
                        | replacemedicaltype: row?.data?.medicalBillType?.value
                        | replaceassettype
                          : (this.currentLang == 'en'
                              ? row?.data?.assetType?.value
                              : row?.data?.assetType?.spValue)
                        | globalTranslate
                        | restoreindiv: row.data?.casehead?.fullName
                    "
                  ></strong
                  ><br />
                  @if (!shouldSkipGlobalTranslate(item)) {
                  <span
                    [innerHtml]="item.value | globalTranslate | sanitize"
                  ></span>
                  } @if (shouldSkipGlobalTranslate(item)) {
                  <span [innerHtml]="item.value | sanitize"></span>
                  }
                </span>
                }
              </div>
              } @if (row.greaterLength) {
              <div class="pt-1">
                <span
                  [innerHTML]="'SUMMARY_STATIC_TEXT2' | globalTranslate"
                ></span>
                <strong
                  [innerHTML]="'SUMMARY_STATIC_TEXT2_01' | globalTranslate"
                ></strong>
                <span
                  [innerHTML]="'SUMMARY_STATIC_TEXT2_02' | globalTranslate"
                ></span>
              </div>
              }
            </div>
            } @if (row.changeValue.length === 0 && !checkIndvs(row)) {
            <div>
              <div>
                {{ text2 | globalTranslate }}
                {{ row.nameAge ? row.nameAge.split(",")[0] : "Person"
                }}{{ "'s" | globalTranslate }} {{ text1 | globalTranslate }}
              </div>
              @if (!closeIncomenudge) {
              <div>
                @if ((sectionId === 'ICEMI' || sectionId === 'ICSEM' ||
                sectionId === 'ICOTH') && incomeReviewStatus) {
                <nh-nudge
                  [message]="'NUDGETEXT_02' | globalTranslate"
                ></nh-nudge>
                }
              </div>
              }
            </div>
            } @if (checkIndvs(row)) {
            <div>
              <div>{{ text3En | globalTranslate }} {{ this.updateDate }}</div>
            </div>
            }
          </span>
          } @if (isObject(row) && row.exportingStatus === 'REMOVED') {
          <span>
            @for (item of row.changeValue; track item) {
            <div class="pt-1">
              <span
                [innerHTML]="
                  item.key
                    | translate
                    | replaceindiv: row.indivName:row.data?.recordRemovedType
                    | globalTranslate
                    | restoreindiv: row.indivName:row.data?.recordRemovedType
                "
              ></span>
              @if (!shouldSkipGlobalTranslate(item)) {
              <span> {{ item.value | globalTranslate }}</span>
              } @if (shouldSkipGlobalTranslate(item)) {
              <span> {{ item.value }}</span>
              }
            </div>
            }
          </span>
          }
        </td>
        <td class="text-center">
          <span class="summary-ctas">
            <button
              class="btn btn-sm btn-secondary mb-1 edit-{{ rowIndex }}"
              [disabled]="
                sectionId === 'HHTJF' &&
                row?.data?.taxFilingStatus !== 'Filer' &&
                  row?.data?.taxFilingStatus !== null &&
                enableEditReview
              "
              (click)="onEdit(row)"
            >
              {{
                (this.isRMC
                  ? this.editText
                  : !this.isRMC && row.exportingStatus == "EXPORTED"
                  ? this.review
                  : this.editText
                ) | globalTranslate
              }}
            </button>
            @if (row.exportingStatus === 'REMOVED' && row.identifier.sectionId
            !== 'OTKBR') {
            <div class="ps-2 pt-1 hover-red">
              <a
                class="btn btn-lg btn-link delete-1 hover-red p-1 delete-{{
                  rowIndex
                }}"
                (click)="onUndo(row)"
              >
                <span class="pe-2">{{ "Undo" | globalTranslate }}</span>
                <svg
                  id="_icons_arrow_undo-outline{{ rowIndex }}"
                  data-name="⚛️ icons/icons-arrow-undo-outline"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
                    fill="#174a7c"
                    stroke="none"
                  >
                    <path
                      d="M65 160 l-39 -40 39 -40 c44 -45 55 -49 55 -20 0 27 30 26 64 -1 34
                                  -27 38 -22 25 24 -10 36 -50 77 -75 77 -8 0 -14 9 -14 20 0 29 -11 25 -55 -20z
                                  m81 -19 c20 -7 40 -24 46 -37 14 -30 6 -39 -20 -25 -29 15 -60 14 -64 -3 -2
                                  -11 -12 -7 -38 15 l-35 29 35 29 c22 19 36 25 38 17 1 -7 19 -18 38 -25z"
                    />
                  </g>
                </svg>
              </a>
            </div>
            } @if (row.exportingStatus !== 'REMOVED' && row.identifier.sectionId
            !== 'OTKBR') {
            <div class="pt-1 hover-red">
              <button
                class="btn btn-link btn-lg delete-{{ rowIndex }} hover-red p-1"
                [disabled]="
                  enableEditReview &&
                  (!canDelete(row) ||
                    row?.data?.taxFilingStatus?.includes('Dependent') ||
                    row?.data?.taxFilingStatus?.includes('Joint'))
                "
                (click)="onDelete(row)"
              >
                <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                @if (canDelete(row)) {
                <nh-remove-svg id="web_count"></nh-remove-svg>
                }
              </button>
              @if (!canDelete(row)) {
              <nh-popover
                [content]="
                  popContent | globalTranslate | restoreindiv: personName
                "
              ></nh-popover>
              }
            </div>
            } @if (sectionId === 'HHTJF' && row.data.taxFilingStatus !== 'Filer'
            && enableEditReview) {
            <nh-popover
              [content]="
                (taxPopUpOne | globalTranslate) +
                person[rowIndex].name +
                (person[rowIndex].status === 'EDIT'
                  ? (taxPopUpTwo | globalTranslate)
                  : (taxPopUpThree | globalTranslate))
              "
            ></nh-popover>
            }
          </span>
        </td>
        @if (!this.isRMC) {
        <td class="text-center">
          @if (row.exportingStatus == 'EXPORTED') {
          <span class="text-danger"
            ><i
              role="img"
              class="fa fa-times fa-2x"
              [attr.aria-label]="
                'REVIEW_STATUS_NOT_COMPLETED' | globalTranslate
              "
            ></i
          ></span>
          } @if (row.exportingStatus !== 'EXPORTED') {
          <span class="text-success"
            ><i
              role="img"
              class="fa fa-check fa-2x"
              [attr.aria-label]="'REVIEW_STATUS_COMPLETED' | globalTranslate"
            ></i
          ></span>
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>

<div class="nh-table-mobile mt-3 pt-2 d-lg-none">
  @for (row of rowData; track row; let i = $index) {
  <div class="table-row mb-3 pb-3">
    <div class="mobile-table-header">{{ "NAME" | globalTranslate }}</div>
    <hr />
    <div class="mobile-table-data">{{ row.nameAge }}</div>
    <br />
    <div class="mobile-table-header">
      {{ "What Changed?" | globalTranslate }}
    </div>
    <hr />
    <div class="mobile-table-data">
      @if (!isObject(row)) {
      <span
        [innerHtml]="
          row.changeValue
            | globalTranslate
            | restoreindiv: row.indivName
            | sanitize
        "
      ></span>
      } @if (isObject(row) && row.exportingStatus !== 'REMOVED') {
      <span>
        @if (row.changeValue.length > 0) {
        <div>
          @for (item of row.changeValue; track item) {
          <div class="pt-1">
            <strong
              [innerHTML]="
                item.key
                  | translate
                  | replaceindiv: row.nameAge
                  | replacemedicaltype: row?.data?.medicalBillType?.value
                  | replaceassettype
                    : (this.currentLang == 'en'
                        ? row?.data?.assetType?.value
                        : row?.data?.assetType?.spValue)
                  | globalTranslate
                  | restoreindiv: row.nameAge
              "
            ></strong
            ><br />
            @if (!shouldSkipGlobalTranslate(item)) {
            <span [innerHtml]="item.value | globalTranslate | sanitize"></span>
            } @if (shouldSkipGlobalTranslate(item)) {
            <span [innerHtml]="item.value | sanitize"></span>
            }
          </div>
          } @if (row.greaterLength) {
          <div>
            <span [innerHTML]="'SUMMARY_STATIC_TEXT2' | globalTranslate"></span>
            <strong
              [innerHTML]="'SUMMARY_STATIC_TEXT2_01' | globalTranslate"
            ></strong>
            <span
              [innerHTML]="'SUMMARY_STATIC_TEXT2_02' | globalTranslate"
            ></span>
          </div>
          }
        </div>
        } @if (row.changeValue.length === 0) {
        <div>
          <div>
            {{ text2 | globalTranslate }}
            {{ row.nameAge ? row.nameAge.split(",")[0] : "Person"
            }}{{ "'s" | globalTranslate }} {{ text1 | globalTranslate }}
          </div>
          @if (!closeIncomenudge) {
          <div>
            @if ((sectionId === 'ICEMI' || sectionId === 'ICSEM' || sectionId
            === 'ICOTH') && incomeReviewStatus) {
            <nh-nudge [message]="'NUDGETEXT_02' | globalTranslate"></nh-nudge>
            }
          </div>
          }
        </div>
        }
      </span>
      } @if (isObject(row) && row.exportingStatus === 'REMOVED') {
      <span>
        @for (item of row.changeValue; track item) {
        <div class="pt-1">
          <span
            [innerHTML]="
              item.key
                | translate
                | replaceindiv: row.indivName:row.data?.recordRemovedType
                | globalTranslate
                | restoreindiv: row.indivName:row.data?.recordRemovedType
            "
          ></span>
          @if (!shouldSkipGlobalTranslate(item)) {
          <span>{{ item.value | globalTranslate }}</span>
          } @if (shouldSkipGlobalTranslate(item)) {
          <span>{{ item.value }}</span>
          }
        </div>
        }
      </span>
      }
    </div>
    <br />
    <div>
      <button
        class="btn btn-sm btn-secondary mb-1 w-100 edit-{{ i }}"
        [disabled]="
          sectionId === 'HHTJF' &&
          row?.data?.taxFilingStatus !== 'Filer' &&
            row?.data?.taxFilingStatus !== null &&
            row?.data?.taxFilingStatus !== 'Out of Household Dependent'
        "
        (click)="onEdit(row)"
      >
        {{
          (this.isRMC
            ? this.editText
            : !this.isRMC && row.exportingStatus == "EXPORTED"
            ? this.review
            : this.editText
          ) | globalTranslate
        }}
      </button>
      @if (row.exportingStatus !== 'REMOVED' && row.identifier.sectionId !==
      'OTKBR') {
      <div class="pt-1 hover-red text-center">
        <button
          class="btn btn-link btn-lg delete-{{ i }} hover-red"
          [disabled]="
            enableEditReview &&
            (!canDelete(row) ||
              row?.data?.taxFilingStatus?.includes('Dependent') ||
              row?.data?.taxFilingStatus?.includes('Joint')) &&
            row?.data?.taxFilingStatus !== 'Out of Household Dependent'
          "
          (click)="onDelete(row)"
        >
          <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
          @if (canDelete(row)) {
          <nh-remove-svg id="mobile_count"></nh-remove-svg>
          }
        </button>
        @if (!canDelete(row)) {
        <nh-popover
          [content]="popContent | globalTranslate | restoreindiv: personName"
        ></nh-popover>
        } @if (sectionId === 'HHTJF' && row.data.taxFilingStatus !== 'Filer') {
        <nh-popover
          [content]="
            (taxPopUpOne | globalTranslate) +
            person[i].name +
            (person[i].status === 'EDIT'
              ? (taxPopUpTwo | globalTranslate)
              : (taxPopUpThree | globalTranslate))
          "
        ></nh-popover>
        }
      </div>
      } @if (row.exportingStatus === 'REMOVED' && row.identifier.sectionId !==
      'OTKBR') {
      <div class="ps-2 pt-1 hover-red text-center">
        <a
          class="btn btn-lg btn-link delete-1 hover-red p-1 delete-{{ i }}"
          (click)="onUndo(row)"
        >
          <span class="pe-2">{{ "Undo" | globalTranslate }}</span>
          <svg
            id="_icons_arrow_undo-outline{{ i }}"
            data-name="⚛️ icons/icons-arrow-undo-outline"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g
              transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
              fill="#174a7c"
              stroke="none"
            >
              <path
                d="M65 160 l-39 -40 39 -40 c44 -45 55 -49 55 -20 0 27 30 26 64 -1 34
                                  -27 38 -22 25 24 -10 36 -50 77 -75 77 -8 0 -14 9 -14 20 0 29 -11 25 -55 -20z
                                  m81 -19 c20 -7 40 -24 46 -37 14 -30 6 -39 -20 -25 -29 15 -60 14 -64 -3 -2
                                  -11 -12 -7 -38 15 l-35 29 35 29 c22 19 36 25 38 17 1 -7 19 -18 38 -25z"
              />
            </g>
          </svg>
        </a>
      </div>
      }
    </div>
    <br />
    @if (!isRMC) {
    <div>
      <div class="mobile-table-header">
        {{ "Review Complete?" | globalTranslate }}
      </div>
      <hr />
      <div>
        @if (row.exportingStatus == 'EXPORTED') {
        <span class="text-danger"
          ><i
            role="img"
            class="fa fa-times fa-2x"
            [attr.aria-label]="'REVIEW_STATUS_NOT_COMPLETED' | globalTranslate"
          ></i
        ></span>
        } @if (row.exportingStatus !== 'EXPORTED') {
        <span class="text-success"
          ><i
            role="img"
            class="fa fa-check fa-2x"
            [attr.aria-label]="'REVIEW_STATUS_COMPLETED' | globalTranslate"
          ></i
        ></span>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
